/**
 * Date formatting utilities for Influencia & Poder
 * All dates displayed in EST (Eastern Standard Time)
 */

/**
 * Format date to EST timezone with full date and time
 * @param {string|Date} date - The date to format
 * @returns {string} Formatted date string in EST
 */
export const formatDateEST = (date) => {
  if (!date) return '';
  
  const d = new Date(date);
  
  // Format date part
  const datePart = d.toLocaleDateString('es-ES', {
    timeZone: 'America/New_York',
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  });
  
  // Format time part manually for correct AM/PM
  const timeOptions = {
    timeZone: 'America/New_York',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  };
  const timePart = d.toLocaleTimeString('en-US', timeOptions);
  
  return `${datePart}, ${timePart} EST`;
};

/**
 * Format date to EST timezone - short version (for cards)
 * @param {string|Date} date - The date to format
 * @returns {string} Formatted date string in EST
 */
export const formatDateESTShort = (date) => {
  if (!date) return '';
  
  const d = new Date(date);
  
  const datePart = d.toLocaleDateString('es-ES', {
    timeZone: 'America/New_York',
    day: 'numeric',
    month: 'short'
  });
  
  const timePart = d.toLocaleTimeString('en-US', {
    timeZone: 'America/New_York',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
  
  return `${datePart}, ${timePart} EST`;
};

/**
 * Format date to EST timezone - date only
 * @param {string|Date} date - The date to format
 * @returns {string} Formatted date string in EST
 */
export const formatDateOnlyEST = (date) => {
  if (!date) return '';
  
  const d = new Date(date);
  
  return d.toLocaleDateString('es-ES', {
    timeZone: 'America/New_York',
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
};

/**
 * Format relative time (e.g., "hace 2 horas")
 * @param {string|Date} date - The date to format
 * @returns {string} Relative time string
 */
export const formatRelativeTime = (date) => {
  if (!date) return '';
  
  const d = new Date(date);
  const now = new Date();
  const diffMs = now - d;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);
  
  if (diffMins < 1) return 'Ahora';
  if (diffMins < 60) return `Hace ${diffMins} min`;
  if (diffHours < 24) return `Hace ${diffHours}h`;
  if (diffDays < 7) return `Hace ${diffDays} días`;
  
  return formatDateESTShort(date);
};
